/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getUrlForDomainInContext } from '@atlaskit/atlassian-context/get-url-for-domain-in-context';
import getLocation from '@atlassian/jira-common-location/src/index.tsx';
import { LOGIN, LOGOUT } from './constants.tsx';

export const getWindow = (): Window | null => (__SERVER__ ? null : window);

export const getContinueUrl = ({ type }: { type: typeof LOGIN | typeof LOGOUT }): string => {
	const { href = '', protocol = '', host = '' } = getLocation() ?? {};

	if (type === LOGIN) {
		return href;
	}

	if (type === LOGOUT) {
		return protocol && host ? `${protocol}//${host}` : '';
	}

	return '';
};

const resolveIdentityEnv = (env: Environment) => {
	switch (env) {
		case 'local':
			return 'staging';
		case 'dev':
			return 'staging';
		case 'staging':
			return 'staging';
		case 'prod':
			return 'prod';
		default:
			return 'prod';
	}
};

export type Environment = 'prod' | 'staging' | 'dev' | 'local' | null;
export const getIdentityEnv = (
	env: Environment,
):
	| 'prod'
	| 'staging'
	| {
			baseUrl: string;
	  } => {
	const resolvedEnvironment = resolveIdentityEnv(env);
	const urlForDomain = getUrlForDomainInContext('id', resolvedEnvironment);
	if (urlForDomain === undefined) {
		return resolvedEnvironment;
	}
	return {
		baseUrl: urlForDomain,
	};
};
